export class EntityNotificationGroupDto {
  EntityNotificationGroupId?: number;
  NotificationGroupId: number;
  PortalId: string;
  Active: boolean;

  constructor(notificationGroupId: number, portalId: string, active: boolean, entityNotificaitonGroupId?: number) {
    this.NotificationGroupId = notificationGroupId;
    this.PortalId = portalId;
    this.Active = active;
    this.EntityNotificationGroupId = entityNotificaitonGroupId;
  }
}
